import { StaticImage } from "gatsby-plugin-image"
import { Fragment, useState } from "react"

import { Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

import { products } from "../resources"

import Product from "./product"
import ProductDetailsDialog from "./product-details-dialog"

const Products = () => {
  const [dialogData, setDialogData] = useState(null)

  return (
    <Fragment>
      <div
        sx={{
          mb: 6,
          border: "1px",
          borderColor: ["grey", "transparent"],
          borderRadius: "8px",
          overflow: "hidden",
          display: [null, "grid"],
          gridTemplateColumns: [null, "1fr 1fr"],
        }}
      >
        <StaticImage
          src="../../../../images/rebranded/rebranded-product-set.png"
          alt=""
          sx={{
            width: "100%",
          }}
        />
        <div sx={{ pt: 4, px: 4, pb: 5 }}>
          <Heading as="h3" size="xsm" mb={4} sx={{ lineHeight: "body" }}>
            <Trans i18nKey="ChoosePlan.Products.title" />
          </Heading>

          {products.map((product, index) => (
            <Product
              key={index}
              onClick={() => setDialogData(product.details)}
              {...product}
              sx={{
                "&:not(:last-of-type)": {
                  mb: 3,
                },
              }}
            />
          ))}
        </div>
      </div>
      <ProductDetailsDialog
        {...dialogData}
        isOpen={Boolean(dialogData)}
        onDismiss={() => setDialogData(null)}
      />
    </Fragment>
  )
}

export default Products
